var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMobile)?_c('transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',[_c('navigation',[_c('router-view',{staticClass:"child-view"})],1)],1)],1):_c('transition',[_c('keep-alive',{attrs:{"exclude":"grading,gradeevaluation,sharedetail,stuDetail,repeatReport"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-407deafc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/u-view.vue
// module id = null
// module chunks = 